import { useCallback } from 'react';
import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { ReachStep } from './Reach';

async function LoadReachStep(): Promise<typeof ReachStep> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-reach" */ './Reach')).ReachStep;
}

export function ReachLoader(): JSX.Element {
	const loadComponent = useCallback(LoadReachStep, []);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadReachStep = LoadReachStep;
